import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription, of, Subject } from 'rxjs';
import { TlumaczeniaService } from 'src/app/core/tlumaczenia/serwisy/tlumaczenia.service';
import { TagiDto } from '../../../modele/tagi';
import { TagiService } from '../../../serwisy/tagi.service';
import { WIDOKI_MAPY_ID } from 'src/app/modul-mapowy/stan/mapa-widok/mapa-widok.const';
import { InterfejsUzytkownikaStan } from 'src/app/modul-mapowy/stan/interfejs-uzytkownika/interfejs-uzytkownika.reducer';
import { Store } from '@ngrx/store';
import { InterfejsUzytkownikaActions } from 'src/app/modul-mapowy/stan/interfejs-uzytkownika/interfejs-uzytkownika.actions';
import { LewyPanelWidokActions } from 'src/app/modul-mapowy/stan/lewy-panel-widok/lewy-panel-widok.actions';
import { WIDOK_TAGI } from 'src/app/modul-mapowy/stan/lewy-panel-widok/lewy-panel-widok.const';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mm-obiekt-tagi',
  templateUrl: './obiekt-tagi.component.html',
  styleUrls: ['./obiekt-tagi.component.scss'], changeDetection: ChangeDetectionStrategy.Default
})
export class ObiektTagiComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tagi: string | undefined;
  @Output() zamknij = new EventEmitter<void>();
  WIDOKI_MAPY_ID = WIDOKI_MAPY_ID;

  interfejsUzytkownika$: Observable<InterfejsUzytkownikaStan>;
  subscrybcje$ = new Subscription();
  private destroy$ = new Subject<void>();

  tagiArr: string[] = []
  tagiArr$: Observable<string[]> | undefined;
  aktualnyJezyk = '';
  zmianaJezykaSubscription?: Subscription;
  tagiAll: TagiDto[] | undefined;
  tagiToDisplay: TagiDto[] = [];
  tagiToDisplay$: Observable<TagiDto[]> | undefined;
  /**
   * KOnstruktor
   * @param tlumaczenia
   */
  constructor(private tlumaczenia: TlumaczeniaService,
    private tagiServis: TagiService,
    private store: Store<{ modulMapowy: any }>) {
    this.interfejsUzytkownika$ = store.select('modulMapowy', 'interfejsUzytkownika');
  }

  /**
   * Cykl życia komponentu inicjalizacja
   */
  ngOnInit(): void {

    this.zmianaJezykaSubscription = this.tlumaczenia.getZmianaJezykaSubject()
      .pipe(takeUntil(this.destroy$))
      .subscribe(jezyk => {
        this.aktualnyJezyk = jezyk;
      });
    this.tagiServis.getTagi()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.tagiAll = result;
        this.updateTagiArrAndDisplay();
      });
  }

  /**
   * Cykl życia komponentu niszczenie
   */
  ngOnChanges(): void {
    if (this.tagiAll) {
      this.updateTagiArrAndDisplay();
    }

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.tagiArr = [];
    this.tagi = '';
  }

  private updateTagiArrAndDisplay() {
    if (this.tagi) {
      this.tagiArr = this.tagi.split(",");
      this.przygotujListeTagow(this.tagiArr);
      this.tagiArr$ = of(this.tagiArr);
    }
  }

  /**
   * Przygotowuje listę tagów do wyświetlenia na podstawie przekazanej tablicy nazw tagów.
   * Dla każdego tagu w tablicy wejściowej wyszukuje odpowiadający obiekt TagiDto w tagiAll.
   * Jeśli znajdzie, dodaje go do listy tagiToDisplay, która jest następnie emitowana jako Observable.
   *
   * @param tagiArr Tablica nazw tagów (stringów) do wyszukania w tagiAll
   */
  przygotujListeTagow(tagiArr: string[]) {
    this.tagiToDisplay = [];
    let tag: TagiDto | undefined;
    tagiArr.forEach((t) => {
      // Szuka obiektu tagu po nazwie (pl) i dodaje do listy wyświetlanych tagów
      tag = this.tagiAll!.find((ta) => ta.tag.pl?.toLowerCase() == t.trim().toLowerCase());
      if (tag) { this.tagiToDisplay.push(tag); }
    })
    this.tagiToDisplay$ = of(this.tagiToDisplay!);
  }

  /**
   * Obsługuje kliknięcie w tag - zapisuje id tagu do sessionStorage,
   * rozwija lewą belkę, zwija wyszukiwarkę i przełącza widok na tagi,
   * a następnie emituje zdarzenie zamknięcia komponentu.
   *
   * @param event Obiekt TagiDto wybranego tagu
   */
  wyszukajPoTagu(event: TagiDto) {
    sessionStorage.setItem('tag', event.tagid + '');
    this.store.dispatch(InterfejsUzytkownikaActions.rozwinLewaBelke());
    this.store.dispatch(InterfejsUzytkownikaActions.zwinWyszukiwarke());
    this.store.dispatch(LewyPanelWidokActions.pokazObszar({ widokId: WIDOK_TAGI.id }));
    this.zamknij.emit();
  }

}
